/* eslint-disable react/display-name */
/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['kindTertiaryOutline', 'kindTertiarySolid', 'kindPrimary', 'kindPrimarySolid', 'kindPrimarySolid', 'kindDestructiveSolid', 'kindTertiaryLink', 'kindPrimaryLink', 'kindDestructiveLink'] }] */
import { forwardRef } from 'react';
import classNames from 'classnames';
import { Button } from './Button';
import css from './IconButton.module.scss';
const IconButton = forwardRef((props, ref) => {
    const { 'aria-label': ariaLabel, children, className, kind, renderAs, ...restProps } = props;
    return (<Button ref={ref} aria-label={ariaLabel} renderAs={renderAs} kind={kind} className={classNames(css.iconButton, {
        [css.iconButtonSquare]: kind === 'tertiaryOutlineSquare'
    }, className)} {...restProps}>
      {children}
    </Button>);
});
export { IconButton };
//# sourceMappingURL=IconButton.jsx.map